import * as CONST from '@/constants'
import * as utils from '@/utils/main_utils'
import axios from '@/utils/axios_iface'

export default {
  state: {
    driverInformation: false, //has jeebly and other order status
    order_status: false, //has store order information
    force_reload: true,
    order_id: false,
    trackingOrder: false,
  },
  getters: {
    getDriverInformation: state => {
      return state.driverInformation
    },
    orderStatusHistoryTime: status => (order, status) => {
      if (order && order.order_history) {
        let matchHistory = order.order_history.find(
          history => history.name === status
        )
        if (matchHistory) {
          // datetime_in_store_timezone function has issue regarding all_stores_being_loaded
          /*let storeTime = utils.datetime_in_store_timezone(matchHistory.created_at, order.store_id)
                    if (!storeTime) {*/
          return utils.datetime_in_local_timezone(
            matchHistory.created_at,
            'hh:mm:ss A'
          )
          // }
          // return storeTime.date
        } else return false
      }
      return false
    },
    orderStatusKitchenTime: status => order => {
      if (
        order &&
        order.kitchen_history &&
        order.kitchen_history.finished.length
      ) {
        return utils.datetime_in_local_timezone(
          order.kitchen_history.finished[
            order.kitchen_history.finished.length - 1
          ].updated_at,
          'hh:mm:ss A'
        )
      }
      return false
    },
    markers: (state, getters) => {
      let mapDetails = getters.map_coordinates
      if (mapDetails && mapDetails.driver_position) {
        return [mapDetails.origin, mapDetails.driver_position]
      }
      return mapDetails ? [mapDetails.origin, mapDetails.destination] : []
    },
    orderStatus: (state, getters) => status => {
      // console.log(getters.selected_order, state.order_status, 'dddeee')
      let order_status = state.order_status || getters.selected_order
      let make_const = 'IN_PROGRESS'
      if (
        order_status.order_system_status ===
        CONST.ORDER_SYSTEM_STATUS_ACCEPTANCE
      ) {
        make_const = order_status.order_system_status.toUpperCase()
        return CONST[make_const]
      } else if (
        order_status.order_system_status === CONST.ORDER_SYSTEM_STATUS_REJECTED
      ) {
        return 'Order Rejected'
      }
      if (status) {
        make_const = status.replace(/-/g, '_').toUpperCase()
        return CONST[make_const]
      }
      return status
    },
    track_order: state => {
      return state.trackingOrder
    },
    track_order_data: state => {
      return state.trackingOrder.item
    },
  },
  actions: {
    orderTracking({ dispatch, getters, commit, state }, orderId) {
      /*dispatch('order_status_tracking', {order_id: orderId, force_reload: state.force_reload}, {
                    root: true,
                }).then(() => {*/
      dispatch('getTrackingOrderById', orderId)
        .then(() => {
          let orderDetails = getters.track_order
          commit('SET_ORDER', orderDetails.item, {
            root: true,
          })
          commit('PLACED_ORDER_ID', false)
          commit('ORDER_TRACKING', orderDetails.item)
          let orderStatus = state.order_status
          if (orderStatus.order_system_status === 'rejected') {
            dispatch('orderRejection', orderDetails.item)
          }
          if (orderDetails.delivery_data) {
            commit('DRIVER_INFORMATION', orderDetails.delivery_data)
            let riderData = state.driverInformation.rider_data
            let orderStatus = {
              updated_at: riderData.updated_at,
              order_status: riderData.event,
              order_system_status: riderData.event,
            }
            if (riderData.event === 'cancelled') {
              dispatch('orderRejection', orderDetails.item)
              orderStatus.order_system_status = 'rejected'
            }
            commit('ORDER_TRACKING', orderStatus)
          } else {
            if (orderDetails.item.driver) {
              let driverDetails =
                orderDetails.page_lookups.users._id[orderDetails.item.driver]
              let prepareDriverInformationForStore = {
                rider_data: {
                  rider_name: driverDetails.name,
                  mobile_number: false,
                  picture: driverDetails.avatar,
                  event: false,
                },
              }
              commit('DRIVER_INFORMATION', prepareDriverInformationForStore)
            }
          }
          // dispatch('mapDetails', orderDetails.item, { root: true })
        })
        .catch(error => {
          // sometime due to server issue API failed to load,
          // customer should not wait for 100 sec for data
          // dispatch('orderTracking', orderId)
        })
    },
    async getTrackingOrderById({ getters, commit }, orderId) {
      if (orderId) {
        await axios
          .get(`${getters.get_single_order_tracking_url + orderId}`)
          .then(response => {
            commit('TRACKING_ORDER', response.data)
          })
      }
    },
    orderRejection({ dispatch }, order) {
      dispatch('showNotification', {
        text: 'Sorry! Your order has been cancelled by store.',
        status: 'error',
        redirect_to: 'home',
      })
      dispatch('revertCouponCode', order)
    },
  },
  mutations: {
    RESET_TRACKING: state => {
      state.driverInformation = false
      state.order_status = false
    },
    DRIVER_INFORMATION: (state, information) => {
      state.driverInformation = information
    },
    /*UPDATE_DRIVER_LOCATION: (state, geom) => {
            state.driverInformation.rider_data.geom = geom
        },*/
    PLACED_ORDER_ID: (state, order_id) => {
      state.order_id = order_id
    },
    TRACKING_ORDER: (state, trackingOrder) => {
      state.trackingOrder = trackingOrder
    },
    ORDER_TRACKING: (state, order_details) => {
      if (!order_details) state.order_status = false
      else {
        let order = order_details
        state.order_status = {
          time: order.updated_at,
          status: order.order_status,
          order_system_status: order.order_system_status,
        }
      }

      /* if (order_details.jeebly_data) {
                state.delivery_by = order_details.jeebly_data.rider_data
            }*/
    },
  },
}
